import React from "react";

const EditClosureModal = ({
  data,
  isSaving = false,
  onClose,
  onSave,
  onFieldChange,
  formatTime,
}) => {
  if (!data) return null;

  const { dockName, dateStr, start, end, reopenFrom, reopenTo } = data;
  const format = formatTime || ((value) => value);

  return (
    <div className="fixed inset-0 z-[1200] bg-black/40 flex items-center justify-center px-fluid-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-xl p-fluid-4 space-y-fluid-3">
        <div className="flex items-start justify-between gap-fluid-2">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Edit closure</h3>
            <p className="text-sm text-gray-600">
              {dockName} on {dateStr} ({format(start)} - {format(end)})
            </p>
          </div>
          <button
            onClick={() => !isSaving && onClose?.()}
            className="text-gray-500 hover:text-gray-700 text-xl leading-none"
            aria-label="Close"
            disabled={isSaving}
          >
            ×
          </button>
        </div>

        <div className="space-y-fluid-2">
          <div>
            <label className="block text-xs font-semibold text-gray-700 mb-1">
              Reopen from
            </label>
            <input
              type="time"
              value={reopenFrom}
              onChange={(e) => onFieldChange?.("reopenFrom", e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-2 w-full text-sm focus:border-[#1e2a74] focus:outline-none"
              disabled={isSaving}
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-gray-700 mb-1">
              Reopen until
            </label>
            <input
              type="time"
              value={reopenTo}
              onChange={(e) => onFieldChange?.("reopenTo", e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-2 w-full text-sm focus:border-[#1e2a74] focus:outline-none"
              disabled={isSaving}
            />
          </div>
          <p className="text-xs text-gray-500">
            The closure will be split around this window. If you reopen the full range, the closure will be removed.
          </p>
        </div>

        <div className="flex items-center justify-end gap-fluid-2 pt-fluid-2">
          <button
            onClick={onClose}
            disabled={isSaving}
            className="px-fluid-button-x py-fluid-button-y rounded-full border border-gray-300 text-gray-700 hover:bg-gray-50 font-semibold disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onSave}
            disabled={isSaving}
            className="px-fluid-button-x py-fluid-button-y rounded-full bg-[#223688] text-white hover:opacity-90 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSaving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditClosureModal;
